export { default } from "./MiniSearchSkeleton.jsx";
